var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartSolid = function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.112 52.277-.016-.01-.056-.03-.206-.113q-.267-.148-.752-.432a57 57 0 0 1-2.636-1.655c-2.17-1.442-5.068-3.562-7.975-6.271C11.72 38.404 5.625 30.438 5.625 20.625c0-7.32 6.159-13.125 13.594-13.125 4.372 0 8.287 1.998 10.781 5.129C32.494 9.498 36.409 7.5 40.781 7.5c7.435 0 13.594 5.805 13.594 13.125 0 9.813-6.094 17.779-11.846 23.14-2.907 2.71-5.806 4.83-7.975 6.272a57 57 0 0 1-2.636 1.655 38 38 0 0 1-.957.545l-.057.03-.016.01-.007.003a1.88 1.88 0 0 1-1.762 0z"
  })));
};
export default SvgHeartSolid;